
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M39 24H24v15h15z"}}),_c('path',{staticClass:"i-Vector",attrs:{"stroke":"#234652","stroke-miterlimit":"10","d":"M42 6H6v36h36z"}}),_c('g',{staticClass:"i-equals",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector 4",attrs:{"d":"M27.15 29.4h8.1"}}),_c('path',{staticClass:"i-Vector 5",attrs:{"d":"M27.15 33.9h8.1"}})]),_c('g',{staticClass:"i-division",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector_2",attrs:{"d":"M31.2 13.12a.496.496 0 1 1 0 .991.496.496 0 0 1 0-.991Z"}}),_c('path',{staticClass:"i-Vector_3",attrs:{"d":"M31.2 19.282a.496.496 0 1 1 0 .992.496.496 0 0 1 0-.992Z"}}),_c('path',{staticClass:"i-Vector 3",attrs:{"d":"M27.15 16.8h8.1"}})]),_c('g',{staticClass:"i-plus",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector 1",attrs:{"d":"M17.25 26.7v8.55m0-8.55v8.55"}}),_c('path',{staticClass:"i-Vector 2",attrs:{"d":"M21.525 30.975h-8.55m8.55 0h-8.55"}})]),_c('g',{staticClass:"i-times",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector 1_2",attrs:{"d":"m20.273 13.552-6.046 6.046m6.046-6.046-6.046 6.046"}}),_c('path',{staticClass:"i-Vector 2_2",attrs:{"d":"m20.273 19.598-6.046-6.046m6.046 6.046-6.046-6.046"}})])])
          )
        }
      }
    